<template>
  <tbody class="ppv-negatives-tbody">
    <tr
      class="ppv-negatives-header-row"
      @click="onToggle(trackName)"
    >
      <td colspan="3" class="ppv-td-neg-header">
        <div class="ppv-neg-header-content">
          <v-icon
            class="ppv-neg-chevron"
          >
            {{ isExpanded ? icons.mdiChevronDown : icons.mdiChevronRight }}
          </v-icon>
          <span class="ppv-neg-title">
            {{ $t("ppv.insights.no_positive_cases") }}
            <span class="ppv-neg-count">({{ totalNegativeCount }})</span>
          </span>
        </div>
      </td>
    </tr>

    <template v-if="isExpanded">
      <tr
        v-for="group in negatives"
        :key="group.categoryName"
        class="ppv-neg-row-tr"
      >
        <td class="ppv-td" colspan="3">
          <div class="ppv-neg-item-wrap">
            <span class="ppv-disease-tag">
              {{ group.categoryToken ? $t(group.categoryToken) : group.categoryName }}
            </span>
            <span class="ppv-neg-conditions">
              <span
                v-for="(cond, i) in group.conditions"
                :key="cond.name"
              >{{ cond.token ? $t(cond.token) : cond.name }}<span v-if="i < group.conditions.length - 1">, </span></span>
            </span>
          </div>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import icons from '@/mixins/icons'

export default {
  name: 'PpvNegativesSection',
  mixins: [icons],
  props: {
    negatives: {
      type: Array,
      required: true
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    trackName: {
      type: String,
      required: true
    },
    onToggle: {
      type: Function,
      required: true
    }
  },
  computed: {
    totalNegativeCount() {
      return this.negatives.reduce((sum, group) => sum + group.conditions.length, 0)
    },
  },
}
</script>

<style scoped>
.ppv-negatives-header-row {
  cursor: pointer;
  background: #fff;
}
.ppv-negatives-header-row:hover { 
  background: #f8fafc; 
}
.ppv-td-neg-header {
  padding: 10px 16px;
  border-top: 1px solid #eaedf2;
}
.ppv-neg-header-content {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ppv-neg-chevron {
  color: #8a96a8 !important;
  font-size: 16px !important;
}
.ppv-neg-title {
  font-size: 11px;
  font-weight: 700;
  color: #a0aec0;
  letter-spacing: .05em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ppv-neg-count {
  color: #cbd5e0;
  font-weight: 500;
}
.ppv-neg-item-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding-left: 22px;
}
.ppv-neg-conditions {
  font-size: 14px;
  color: #a0aec0;
  font-weight: 500;
}
.ppv-neg-row-tr .ppv-td {
  border-bottom: 1px solid #eaedf2;
  padding: 8px 16px;
}
.ppv-neg-row-tr:last-child .ppv-td {
  padding-bottom: 20px;
}
.ppv-disease-tag {
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 7px;
  background: #eef7f9;
  color: #2c7a8c;
  font-weight: 600;
}
.ppv-td {
  border-bottom: none;
  padding: 8px 16px;
}
@media (max-width: 800px) {
  .ppv-td-category {
    display: none;
  }
}
</style>
